if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      // onSlideChanged(event) {
      //   const thumbnail = this.elements.thumbnails.querySelector(
      //     `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      //   );
      //   this.setActiveThumbnail(thumbnail);
      // }

      onSlideChanged(event) {
        const currentElement = event.detail.currentElement;
        if (!currentElement || !currentElement.dataset) {
          console.error(
            "Current element is undefined or does not have a dataset"
          );
          return; // Exit the function if currentElement is not valid
        }
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        if (!activeMedia) {
          return;
        }
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia?.classList?.add("is-active");

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: "smooth" });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}

/* ==========================================================================
   Gallery video autoplay

   Plays a product video inline (muted) as soon as its gallery slide comes
   into view, and pauses it when the customer swipes or scrolls away.
   The preview image stays on top until the first frame is ready, so the
   customer never sees an empty grey player while the video buffers.
   Self-contained: remove this whole block to go back to the theme default.
   ========================================================================== */
(function () {
  if (window.galleryVideoAutoplayLoaded) return;
  if (!("IntersectionObserver" in window)) return;
  window.galleryVideoAutoplayLoaded = true;

  // How much of the slide must be on screen before the video starts
  const VISIBLE_RATIO = 0.6;
  // On phones, play the largest rendition up to this height. Only applies
  // when snippets/product-thumbnail.liquid lists more than one <source>.
  const PHONE_MAX_HEIGHT = 720;
  const phone = window.matchMedia("(max-width: 749px)");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const style = document.createElement("style");
  style.textContent = `
    .product__media-item.is-video-inline .product__modal-opener:not(.product__modal-opener--image) {
      display: none;
    }
    .product__media-item.is-video-inline .deferred-media {
      display: block;
      width: 100%;
    }
    .deferred-media.is-video-buffering[loaded] > .deferred-media__poster {
      display: flex;
      z-index: 2;
    }
  `;
  document.head.appendChild(style);

  // Drop the renditions a phone doesn't need before the browser picks one
  function chooseSource(video) {
    const sources = Array.from(video.querySelectorAll("source[data-height]"));
    if (!phone.matches || sources.length < 2) return;

    const fitting = sources.filter(
      (source) => Number(source.dataset.height) <= PHONE_MAX_HEIGHT
    );
    if (!fitting.length) return;

    const best = fitting.reduce((a, b) =>
      Number(b.dataset.height) > Number(a.dataset.height) ? b : a
    );
    sources.forEach((source) => {
      if (source !== best) source.remove();
    });
  }

  function getVideo(slide) {
    const deferredMedia = slide.querySelector("deferred-media");
    if (!deferredMedia) return null;

    let video = deferredMedia.querySelector(":scope > video");
    if (!video) {
      const template = deferredMedia.querySelector("template");
      const source = template && template.content.querySelector("video");
      if (!source) return null;

      video = source.cloneNode(true);
      chooseSource(video);
      // iOS Safari only allows autoplay for muted, inline videos
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.removeAttribute("autoplay");

      // Keep the preview image (and its play icon) on top until the video
      // is really playing. Safari hides the poster the moment play() is
      // called and shows a grey box while it buffers.
      deferredMedia.classList.add("is-video-buffering");
      const ready = () => deferredMedia.classList.remove("is-video-buffering");
      video.addEventListener("playing", ready, { once: true });
      video.addEventListener("timeupdate", () => {
        if (video.currentTime > 0) ready();
      });

      // If autoplay was refused (e.g. iOS Low Power Mode), tapping the
      // preview counts as a user gesture and starts the video.
      const poster = deferredMedia.querySelector(".deferred-media__poster");
      if (poster) {
        poster.addEventListener("click", () => {
          video.muted = true;
          const promise = video.play();
          if (promise) promise.catch(() => {});
        });
      }

      deferredMedia.setAttribute("loaded", true);
      deferredMedia.appendChild(video);
    }

    // Swaps the static preview image for the inline player (see CSS above)
    slide.classList.add("is-video-inline");
    return video;
  }

  function play(slide) {
    const video = getVideo(slide);
    if (!video || reduceMotion.matches) return;

    video.muted = true;
    const promise = video.play();
    if (promise) promise.catch(() => {});
  }

  function pause(slide) {
    const video = slide.querySelector("deferred-media > video");
    if (video && !video.paused) video.pause();
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= VISIBLE_RATIO) {
          play(entry.target);
        } else {
          pause(entry.target);
        }
      });
    },
    { threshold: [0, VISIBLE_RATIO] }
  );

  function init(root) {
    root
      .querySelectorAll("media-gallery .product__media-item")
      .forEach((slide) => {
        if (slide.dataset.videoAutoplay) return;
        if (!slide.querySelector(".media-type-video deferred-media template"))
          return;
        slide.dataset.videoAutoplay = "true";
        observer.observe(slide);
      });
  }

  init(document);
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target)
  );
})();